<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Cancelar o Plano de Saúde
    </h1>
    <!-- <article class="header__page__descricao">
        Ao cancelar o Plano, você cancela todos os beneficiários ao mesmo tempo.
        Para excluir um ou mais dependentes do plano de saúde acesse Menu > Meu Plano de Saúde > Excluir Dependentes do Plano
    </article> -->
</header>
<main class="main__page">
    <section class="main__content__artigo">
        <h2 class="content__artigo__title">Importante Saber!</h2>
        <div class="content__aviso__artigo">
            <p>
                <b>1º</b> - O cancelamento do PROSAÚDE II terá <b class="content__aviso__artigo__destaque">efeito
                    imediato e caráter irrevogável,</b> não admitindo a
                desistência e não estará mais coberto pelo plano, a partir do protocolo desta solicitação à Fundação
                Copel;
            </p>
            <p>
                <b>2°</b> - A solicitação de cancelamento do plano de saúde pelo Beneficiário Titular acarretará
                <b class="content__aviso__artigo__destaque">automaticamente o cancelamento dos dependentes;</b>
            </p>
            <p>
                <b>3º</b> - Qualquer utilização do plano de saúde (exame, cirurgia, etc.), mesmo que autorizada pela
                Fundação
                Copel, <b class="content__aviso__artigo__destaque">não será realizada após a solicitação de
                    cancelamento;</b>
            </p>
            <p>
                <b>4º</b> - As <b class="content__aviso__artigo__destaque">mensalidades vencidas</b> e/ou <b
                    class="content__aviso__artigo__destaque">eventuais coparticipações</b> devidas pela utilização de
                serviços
                realizados <b class="content__aviso__artigo__destaque">antes da solicitação de cancelamento</b> do plano
                de saúde, <b class="content__aviso__artigo__destaque">serão de responsabilidade do
                    Beneficiário Titular,</b>
                nos termos do Regulamento;
            </p>
            <p>
                <b>5º</b> - No caso de utilização do PROSAÚDE II <b
                    class="content__aviso__artigo__destaque">posteriormente ao protocolo de cancelamento, o Beneficiário
                    Titular arcará
                    com 100% do valor da despesa,</b> independente se o atendimento foi realizado em caráter de
                urgência/emergência ou eletivo;
            </p>
            <p>
                <b>6º</b> - <b class="content__aviso__artigo__destaque">Para reingresso</b> no PROSAÚDE II, será
                necessário o preenchimento de um <b class="content__aviso__artigo__destaque">novo pedido de inscrição e
                    de nova declaração de saúde;</b>
            </p>
            <p>
                <b>7º</b> - O <b class="content__aviso__artigo__destaque">retorno ao PROSAÚDE II dentro dos 30 (trinta)
                    dias,</b> contados a partir do protocolo da solicitação
                de cancelamento, <b class="content__aviso__artigo__destaque">ocorrerá sem cumprimento de carências;</b>
            </p>
            <p>
                <b>8º</b> - <b class="content__aviso__artigo__destaque">Após os 30 (trinta) dias</b> do protocolo do
                pedido de cancelamento, <b class="content__aviso__artigo__destaque">será necessário cumprimento das
                    carências</b> previstas em Regulamento, <b class="content__aviso__artigo__destaque">ou apresentação
                    de carta de portabilidade de outra operadora
                    de plano de
                    saúde,</b> desde que o plano seja correspondente aos planos da Fundação Copel;
            </p>
            <p>
                <b>9º</b> - O cancelamento do PROSAÚDE II <b class="content__aviso__artigo__destaque">acarretará a perda
                    do direito à portabilidade de carências</b> (mudança
                de
                plano de saúde sem cumprimento de novos prazos de carência), caso não tenha sido este o motivo de seu
                pedido de cancelamento.
            </p>
        </div>
    </section>
    <!-- <section class="main__content__aviso">
        <article class="row header-aviso">
            <div class="row col-12 pr-0 pl-0 header-aviso-icon">
                <fa-icon [icon]="faTriangleExclamation" class="content__resultado__aviso__icone"></fa-icon>  
                <p class="content__resultado__aviso__conteudo">
                    <span class="content__resultado__aviso__valor">AVISO!</span>
                </p>
            </div>
            <section class="col-12 pr-0 pl-0">
                <span class="content__beneficiarios__title">Ao concordar em cancelar esses beneficiários que terão o plano de saúde cancelado:</span>
            </section>
        </article>
        <div class="main__content__beneficiarios">            
            <table class="content__beneficiarios__table">
                <tr *ngFor="let item of beneficiaries">
                    <b></b> {{item.name}}
                </tr>
            </table>
        </div>
    </section> -->
    <section class="content-aviso col-12">
        <span class="content__beneficiarios__title">Ao concordar, será cancelado o plano de saúde dos seguintes
            beneficiários:</span>
        <br>
        <div class="main__content__beneficiarios">
            <table class="content__beneficiarios__table">
                <tr *ngFor="let item of beneficiaries">
                    <b></b> {{item.name}}                    
                </tr>
                <tr>
                    <b></b> <ng-container *ngIf="!beneficiaries">Carregando...</ng-container>
                </tr>
            </table>
        </div>
    </section>
    <section class="main__content__formulario">
        <h3>Protocolo de cancelamento</h3>
        <form class="main__page__content__form" [formGroup]="this.formContact" (ngSubmit)="adicionarEmail()">
            <section class="content-form">
                <div class="form-group pr-0 pl-0 col-xl-6 col-md-7 col-sm-12">
                    <label class="content_formulario__cancelamento__label" for="exampleInputEmail1">Adicionar e-mail
                        alternativo</label>
                    <input aria-describedby="emailHelp" class="form-control" formControlName="email"
                        id="exampleInputEmail1" placeholder="Informe um e-mail" type="email col-8">
                    <small class="form-text text-muted content_formulario__cancelamento__aviso"
                        *ngIf="formContact.get('email')?.invalid && formContact.get('email')?.touched && formContact.get('email')?.value != null && formContact.get('email')?.value.length == 0">
                        O e-mail informado é inválido!
                    </small>
                </div>
                <div class="col-xl-2 col-md-5 col-sm-12 mt-2">
                    <button class="btn button-primary col-12" type="submit"
                        [disabled]="formContact.get('email')?.invalid">Adicionar</button>
                </div>
            </section>
            <p class="content__title__h3">O protocolo de cancelamento será enviado para os seguintes e-mails</p>
            <section class="content_descricao px-1 col-xl-5 col-md-10 col-sm-12">
                <p class="content_descricao__email" *ngFor="let item of emails;let i = index">
                    <span class="content_descricao__email__valor">
                        <b>- </b> {{item | lowercase}}
                    </span>
                    <fa-icon class="content_descricao__btn" [icon]="faTrash" (click)=removeEmail(i)
                        *ngIf="emails.length > 1">
                    </fa-icon>
                </p>
            </section>
            <div class="form-check formulario__cancelamento__checkbox">
                <input class="form-check-input" formControlName="confirm" id="exampleCheck1" type="checkbox">
                <label class="form-check-label content_formulario__cancelamento__label" for="exampleCheck1">Estou ciente
                    e desejo prosseguir com o cancelamento do plano de saúde.</label>
            </div>
        </form>
    </section>
    <br>
    <br>
    <section class="col-12">
        <button class="btn button-primary" id="btn-cancelamento"
            [disabled]="!formContact.get('confirm')?.value || this.loading" (click)="cancelPlan()">
            Solicitar Cancelamento
        </button>
    </section>
</main>